<template>
<!-- eslint-disable vue/valid-v-slot -->
  <v-container fluid>
    <printHeader class="d-none d-print-flex" ></printHeader>
    <v-data-table
    :headers="headers"
    :items="materialData"
    item-key="Number(startTime)"
    :loading="dataLoading"
    hide-default-header
    hide-default-footer
    :no-data-text="this.$i18n.t('No Data Available')"
    :items-per-page="itemsPerPage"
    :page.sync="page"
    @page-count="pageCount = $event"
  >
    <template v-slot:top>
      <v-toolbar flat  color="secondary darken-1" class="d-print-none mb-6">
              <v-toolbar-title  class="pb-2 primary--text">{{$t('Materials Used')}}</v-toolbar-title>
        <v-layout wrap class="ma-0 pt-8">
          <v-row align="start" class="pt-4">
            <v-col cols="12" sm="1" offset-sm="3" class="mt-n5 py-0">
                <v-tooltip bottom>
                  <template v-slot:activator="{on}">
                    <v-btn icon large color="primary" v-on="on" class="mt-0 dense"
                      @click="csvExport">
                      <v-icon>mdi-microsoft-excel</v-icon>
                    </v-btn>
                  </template>
                  <span>{{$t('Export report data to a file in Excel format')}}</span>
                </v-tooltip>
            </v-col>
            <v-col xs6 sm4 class="px-2 my-0 py-0">
              <PickDate v-model="fromDate" @input="fromDate=$event" :label="$t('From Date')"> </PickDate>
            </v-col>
            <v-col xs6 sm4 class="px-2 my-0 py-0">
              <PickDate v-model="toDate" @input="toDate=$event" :label="$t('To Date')"> </PickDate>
            </v-col>
          </v-row>
         </v-layout>
      </v-toolbar>
      <v-row class="d-none d-print-flex">
        <v-col cols="3"><span class="title">{{$t('Materials Used')}}</span></v-col>
        <v-col cols="4">{{$t('From Date')}}: <u>{{fromDate}}</u></v-col>
        <v-col cols="4">{{$t('To Date')}}: <u>{{toDate}}</u></v-col>
        <v-col cols="1"> </v-col>
      </v-row>
    </template>

    <template v-slot:header="{ props: { headers } }">
      <thead>
        <tr>
          <th v-for="hdr in headers" :key="hdr.index"
            class="subtitle-2 font-weight-bold"
            :class="{'text-right': hdr.align == 'right', 'text-center': hdr.align == 'center'}" >
            {{hdr.text.toUpperCase()}}
          </th>

        </tr>
      </thead>
    </template>

    <template v-slot:item.code="{ item }">
      <span>{{getFeedCode(item)}}</span>
    </template>
    <template v-slot:item.name="{ item }">
      <span>{{getFeedName(item) }}</span>
    </template>
    <template v-slot:item.qty="{ item }">
      <span>{{item.qty | kgString}}</span>
    </template>
    <template v-slot:item.dryMaterial="{ item }">
      <span>{{Math.round(item.dryMaterial) | kgString}}</span>
    </template>
    <template v-slot:item.dryPercent="{ item }">
      <span>{{getDryPercent(item) | percentValue}}</span>
    </template>

  </v-data-table>
      <v-layout class="text-center pt-4">
      <v-flex sx12 sm3>
       <v-select
          :items="perPageList"
          :label="this.$i18n.t('Items per page')"
          :value="itemsPerPage"
          @input="itemsPerPage = parseInt($event, 10)"
          type="number"
          class="my-0 ml-1 mr-0 py-0"
        ></v-select>
      </v-flex>
      <v-flex xs12 sm9>
      <v-pagination v-model="page" :length="pageCount"></v-pagination>
      </v-flex>
      </v-layout>
  </v-container>
</template>

<script>
import PickDate from "../components/common/PickDate";
import getter from "../store/reportGetters";
import printHeader from "../components/common/PrintHeader";

export default {
  name:"ReportMaterials",
  components: {
     "PickDate": PickDate,
     "printHeader": printHeader
  },
  data() {
    return {
      fromDate: "",
      toDate: "",
      page: 1,
      pageCount: 0,
      itemsPerPage: 25,
      dataLoading: true,
      perPageList: [
        {text: "10", value: 10 },
        {text: "25", value: 25 },
        {text: "50", value: 50 },
        {text: "100", value: 100 },
        {text: "1000", value: 1000 },
      ],
      headers: [
        { text: this.$i18n.t('Feed Code'), width: "16%", align: "left", value: "code"},
        { text: this.$i18n.t('Feed Name'), width: "36%", align: "left", value: "name"},
        { text: this.$i18n.t('Qty'), width: "16%", align: "right", value: "qty"},
        { text: this.$i18n.t('Dry Material'), width: "16%", align: "right", value: "dryMaterial"},
        { text: this.$i18n.t('Dry Material') + " %", width: "16%", align: "right", value: "dryPercent"}
      ],
      materialData: [],
    }
  },
  created() {
    let d = new Date();
    d.setDate(d.getDate()-3);
    this.fromDate = d.toISOString().substr(0, 10)
    this.toDate = new Date().toISOString().substr(0, 10)
    this.loadMaterialUsed();
  },
  watch: {
    fromDate: function() {
      if (! this.dataLoading)
      this.loadMaterialUsed();
    },
    toDate: function() {
      if (! this.dataLoading)
      this.loadMaterialUsed();
    },
  },
  methods: {
    getDryPercent(item) {
      if (item.qty == 0)
        return 0
      else
        return Math.round(item.dryMaterial / item.qty * 10000)/100;
    },
    loadMaterialUsed: function() {
      this.dataLoading = true;
      getter.getMaterialsUsed(this.fromDate, this.toDate, this.$store.state).then((data) => {
        this.materialData = data;
        this.dataLoading = false;
      });
    },
    timeFormat(dt) {
      if (!dt) return "";
      return dt.toLocaleDateString(undefined, {timeStyle: "short"})
      //return `${("00" + dt.getHours()).slice(-2)}:${("00" + dt.getMinutes()).slice(-2)}`
    },
    getFeedCode(item) {
      if (item.feed)
        return item.feed.code
      else
        return ""
    },
    getFeedName(item) {
      if (item.feed)
        return item.feed.name
      else
        return ""
    },
    csvExport() {
      let separator = this.$store.getters.getSeparator;
      let csvContent = "data:text/csv;charset=utf-8,";
      csvContent += [
        [this.$i18n.t('Code'), this.$i18n.t('Name'), this.$i18n.t('Qty'), this.$i18n.t('Dry Material')].join(separator),
        ...this.materialData.map(item =>
          [item.feed.code, item.feed.name, item.qty, item.dryMaterial].join(separator))
      ]
        .join("\n")
        .replace(/(^\[)|(\]$)/gm, "");

      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", "matrial-used.csv");
      link.click();
    }
  },
}
</script>

<style>
  .table-border.v-table {
    border:1px solid white !important;
    /* border-right-style: solid;
    border-right-width: 2px;
    border-right-color: azure;
    overflow-x: hidden !important; */
  }
  .table-border .v-data-table__wrapper {
    border:1px solid white;
    table-layout: fixed;
  }
  .v-data-table td, .v-data-table th {
    padding: 0px 4px;
  }


</style>